<template>
  <b-container fluid>
    <h1>Fishion Email Notifications</h1>

    <h3>Search</h3>
    <b-row class=m-1>
      <b-col>
        <b-button block @click="showModal" variant="info">Add New Notification</b-button>
      </b-col>
    </b-row>
    <b-row class=m-1>
      <b-col>
        <b-form-input placeholder="Filter" v-model="filter" />
      </b-col>
    </b-row>
    <b-row class=m-1>
      <b-col>
        <b-table striped hover :items="items" :fields="columns" :filter="filter">
          <template slot="trigger_conditions" slot-scope="data">
            <p v-if="data.item.orderNumber!=null">Order Number: {{data.item.orderNumber}}</p>
            <p v-if="data.item.name!=null">Customer Name: {{data.item.name}}</p>
            <p v-if="data.item.totalPrice!=null">Total Price: {{data.item.totalPrice}}</p>
            <p v-if="data.item.poNumber!=null">PO Number: {{data.item.poNumber}}</p>
            <p v-if="data.item.teamNumber!=null">Team Number: {{data.item.teamNumber}}</p>
            <p v-if="data.item.ccLast4!=null">CC Last 4: {{data.item.ccLast4}}</p>
            <p v-if="data.item.street!=null">Street: {{data.item.street}}</p>
            <p v-if="data.item.city!=null">City: {{data.item.city}}</p>
            <p v-if="data.item.zip!=null">Zip: {{data.item.zip}}</p>
            <p v-if="data.item.state!=null">State: {{data.item.state}}</p>
            <p v-if="data.item.country!=null">Country: {{data.item.country}}</p>
            <p v-if="data.item.email!=null">Customer Email: {{data.item.email}}</p>
            <p v-if="data.item.product!=null">Product Purchased: {{data.item.product}}</p>
          </template>
          <template slot="actions" slot-scope="data">
            <b-row>
              <b-btn variant=secondary @click="onClickEdit(data)">
                Show Triggers
              </b-btn>
              <b-btn variant=danger @click="deleteItem(data)" class="mx-1">
                Delete
              </b-btn>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal class="mb-1" id="notification-form" size="lg" hide-footer>
        <b-form
          @submit="onSubmit"
          @reset="onReset"
        >
          <b-row class="ml-3 mt-1">
            <h3>
              Notification Triggers
            </h3>
          </b-row>
          <div class="row my-3">
            <div class="col-md-6">
              <b-card title="Order Details" class="inner-card">
                <order-details :fields="form.triggers" />
                <b-form-group id="productOrderGroup" label="Product" label-for="productOrderGroup">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <i class='fas fa-fw fa-globe'></i>
                      &nbsp;
                      <i class='fb-icon'></i>
                    </b-input-group-prepend>
                    <b-form-input id="product" type="text" v-model="form.triggers.product" />
                  </b-input-group>
                </b-form-group>
              </b-card>
            </div>
            <div class="col-md-6 my-md-0 my-2">
              <b-card title="Address Details" class="inner-card">
                <address-details :fields="form.triggers" />
              </b-card>
            </div>
          </div>
          <b-alert variant=success show v-if="showSuccess">
            Trigger <span v-if=this.editingRowData>Saved</span><span v-else>Added</span> Successfully
          </b-alert>
          <b-alert variant=warning show v-if="triggersEmpty">
            No Triggers are set, this means you will get an email for EVERY order on the site<br>
            Are you Sure?
          </b-alert>
          <b-alert variant=warning show v-if="!triggersEmpty && emailEmpty">
            Right now, customer email is required to get a notification. Please fill that out if you want to receive notifications.
          </b-alert>
          <b-alert variant=danger show v-if="showError">
            Trigger Failed to <span v-if=this.editingRowData>Save</span><span v-else>Add</span>. Check the console for more details.
          </b-alert>
          <b-form-row class="m-3">
            <b-input v-model="form.recipient" required placeholder="Email to Notify" />
          </b-form-row>
          <div class="row submit-row mt-3">
            <b-button
              type="submit"
              variant="primary"
              class="mx-3"
            ><span v-if=this.editingRowData>Edit</span><span v-else>Add</span></b-button>
            <b-button
              type="reset"
              variant="danger"
            ><span v-if=this.editingRowData>Cancel Changes</span><span v-else>Reset</span></b-button>
          </div>
        </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';
import AddressDetails from './order-forms/AddressDetails';
import OrderDetails from './order-forms/OrderDetails';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      form: {},
      editingRowData: null,
      filter: '',
      items: [],
      columns: [ { key: 'recipient', sortable: true }, { key: 'trigger_conditions', label: "Trigger Conditions (each condition must be met to trigger an email)" }, 'actions'],
      showSuccess: false,
      showError: false,
    };
  },
  components: {
    AddressDetails,
    OrderDetails,
  },
  mounted() {
    this.onReset();
    this.getItems();
  },
  methods: {
    getItems() {
      axios.get(`${BASE_API}/am-old-db/email-notifications/`).then(r => {
        this.items = r.data.map(x => ({
          id: x.id,
          orderNumber: x.order_number,
          name: x.name,
          totalPrice: x.total_price,
          poNumber: x.po_number,
          teamNumber: x.team_number,
          ccLast4: x.cc_last_4,
          street: x.street,
          city: x.city,
          zip: x.zip,
          state: x.state,
          country: x.country,
          email: x.email,
          recipient: x.recipient,
          product: x.product
        }));
      });
    },
    showModal() {
      this.editingRowData = null;
      this.onReset();
      this.$bvModal.show("notification-form");
    },
    onClickEdit(row) {
      this.editingRowData = row.item;
      this.onReset();
      this.$bvModal.show("notification-form");
    },
    deleteItem(row) {
      axios({
        method: 'delete',
        url: `${BASE_API}/am-old-db/email-notifications/${row.item.id}`,
      }).then(() => this.getItems()
      ).catch((error) => { console.log(error) });
    },
    onSubmit(event) {
      event.preventDefault();
      this.showSuccess = false;
      this.showError = false;
      if (this.editingRowData) {
        let flattened = this.formFlattinator(this.form);
        axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/am-old-db/email-notifications/${this.editingRowData.id}`,
          data: flattened,
        }).then(() => {
          this.showSuccess = true;
          this.getItems()
        }).catch((error) => {
          this.showError = true;
          console.error(error)
        });
      } else {
        axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/am-old-db/email-notifications/`,
          data: this.formFlattinator(this.form),
        }).then(() => {
          this.showSuccess = true;
          this.getItems()
        }).catch((error) => {
          this.showError = true;
          console.error(error)
        });
      }
    },
    // Flattinates every form in the ENTIRE TRI-STATE AREA!
    formFlattinator(formData) {
      return {
        orderNumber: formData.triggers.orderNumber,
        email: formData.triggers.email,
        totalPrice: formData.triggers.totalPrice,
        poNumber: formData.triggers.customerPurchaseOrder,
        teamNumber: formData.triggers.teamNumber,
        ccLast4: formData.triggers.ccLastFour,
        name: formData.triggers.address.name,
        street: formData.triggers.address.street,
        city: formData.triggers.address.city,
        zip: formData.triggers.address.zip,
        state: formData.triggers.address.state,
        country: formData.triggers.address.country,
        product: formData.triggers.product,
        recipient: formData.recipient,
        type: 'email',
      }
    },
    onReset(event) {
      if (event) event.preventDefault();
      this.showSuccess = false;
      this.showError = false;
      if (this.editingRowData) {
        this.form.recipient = this.editingRowData.recipient;
        this.form.triggers.orderNumber = this.editingRowData.orderNumber;
        this.form.triggers.email = this.editingRowData.email;
        this.form.triggers.totalPrice = this.editingRowData.totalPrice;
        this.form.triggers.customerPurchaseOrder = this.editingRowData.poNumber;
        this.form.triggers.teamNumber = this.editingRowData.teamNumber;
        this.form.triggers.ccLastFour = this.editingRowData.ccLast4;
        this.form.triggers.address.name = this.editingRowData.name
        this.form.triggers.address.street = this.editingRowData.street;
        this.form.triggers.address.city = this.editingRowData.city;
        this.form.triggers.address.zip = this.editingRowData.zip;
        this.form.triggers.address.state = this.editingRowData.state;
        this.form.triggers.address.country = this.editingRowData.country;
        this.form.triggers.product = this.editingRowData.product;
        this.form.triggers.type = this.editingRowData.type;
      }
      else {
        this.form = {
          triggers: {
            orderNumber: null,
            email: null,
            totalPrice: null,
            customerPurchaseOrder: null,
            teamNumber: null,
            ccLastFour: null,
            address: {
              name: null,
              street: null,
              city: null,
              zip: null,
              state: null,
              country: null,
            },
            product: null,
            type: null,
          },
          recipient: null,
        };
      }
    }
  },
  computed: {
    triggersEmpty() {
      return !this.form || !this.form.triggers || !this.form.triggers.address
        || (!this.form.triggers.orderNumber && !this.form.triggers.email && !this.form.triggers.totalPrice
        && !this.form.triggers.customerPurchaseOrder && !this.form.triggers.teamNumber && !this.form.triggers.ccLastFour
        && !this.form.triggers.address.name && !this.form.triggers.address.street && !this.form.triggers.address.city
        && !this.form.triggers.address.zip && !this.form.triggers.address.state && !this.form.triggers.address.country)
        && !this.form.triggers.product
    },
    emailEmpty() {
      return this.form.triggers.email == null || this.form.triggers.email == '';
    },
  },
}
</script>

<style scoped>
  .card-header {
    background-color: #fff;
  }
  .inner-card {
    background-color: #f3f3f3;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/EmailNotifications.vue